import React from 'react'
import config from 'config'

import RichCta from 'components/rich-cta'
import WidgetPage from 'components/hocs/widget-page'

export const RichCtaApp = (props) => (
  <RichCta
    nmls
    url={`${config.credibleRoot}/mortgage`}
    title="Find the right mortgage for your dream home."
    body="See Your Lender Options in Minutes"
    ctaText="Get Started"
    {...props}
  />
)

export default WidgetPage(RichCtaApp)
